import { FC } from 'react';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components/macro';

const UserIconLoader: FC = () => {
  const theme = useTheme();

  return (
    <ContentLoader
      speed={2}
      width={26}
      height={26}
      backgroundColor={theme.colors.primary.variant6}
      foregroundColor={theme.colors.rgba.variant2}
    >
      <circle cx="13" cy="13" r="13" />
    </ContentLoader>
  );
};

export default UserIconLoader;
